import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { URIEncrypt } from './enum';

function usePagesTitle() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        const titleArray = path.split("/")
        const len = titleArray.length

        let AppTitle = ""
        //set bill type
        if (titleArray.includes(URIEncrypt.Sale))
            AppTitle = "Sale "
        else if (titleArray.includes(URIEncrypt.Purchase))
            AppTitle = "Purchase "
        //set trade type
        if (titleArray.includes(URIEncrypt.Rough))
            AppTitle += "Rough "
        else if (titleArray.includes(URIEncrypt.Polish))
            AppTitle += "Polish "
        else if (titleArray.includes(URIEncrypt.Rejection))
            AppTitle += "Rejection "
        //set diam type
        if (titleArray.includes(URIEncrypt.SinglePacket))
            AppTitle += "Single "
        else if (titleArray.includes(URIEncrypt.Mix))
            AppTitle += "Mix "
        //pay type
        // if (titleArray.includes(URIEncrypt.Receive))
        //     AppTitle += "Receive "
        // else if (titleArray.includes(URIEncrypt.Payment))
        //     AppTitle += "Payment "
        //console.log(titleArray[len - 1])


        if (len > 1) {
            if (titleArray[len - 1] == 'create-entry')
                AppTitle += titleArray[len - 2] + " Entry"
            else if (titleArray[1] == 'sstk-data')
                AppTitle += "Single Packet Stock Report"
            else if (titleArray[1] == 'mstk-data')
                AppTitle += "Mix Stock Report"
            else
                AppTitle += titleArray[len - 1]
        }
        if (AppTitle == "")
            AppTitle = 'DIAM APP | Integrated IT Solution'

        document.title = AppTitle.replace(/\b\w/g, char => char.toUpperCase()) + " | Integrated IT Solution";
    }, [location]);
}

export default usePagesTitle;
